import React from "react";
import Routes from "./Routes";
import { AuthProvider } from './contexts/AuthContext';
import CookieConsentBanner from './components/CookieConsentBanner';

function App() {
  return (
    <AuthProvider>
      <Routes />
      <CookieConsentBanner />
    </AuthProvider>
  );
}

export default App;
